export const VISA_ENDPOINT = process.env.REACT_APP_VISA_ENDPOINT;
export const BASE_URL = "https://payment.rideplus.co";
export const VERSION = "v2";
